<template>
  <RouterView />
</template>

<script>
export default {
  name: 'App',
  components: {
    
  },
  mounted(){
    // 获取域名
    var domain = localStorage.getItem("hostname");
    if(!domain){
      const domain2 = window.location.hostname;
      localStorage.setItem("hostname",domain2);
    }
    // window.
    //setToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vd3d3LnN1YjAwMS5jb20vYXBpL3YxL2xvZ2luIiwiaWF0IjoxNzI5MTA4MDk4LCJleHAiOjE3MzEyNjgwOTgsIm5iZiI6MTcyOTEwODA5OCwianRpIjoiQkJaQW9LdEU0bVh2Yk5oeCIsInN1YiI6IjEiLCJwcnYiOiIyM2JkNWM4OTQ5ZjYwMGFkYjM5ZTcwMWM0MDA4NzJkYjdhNTk3NmY3In0.2wRbUsaHvapICnDEEERHt_rDgSHDnjqhu_9A3VM63F8')
    this.$store.dispatch('routes/addRouter')
    this.$router.beforeEach((to, from, next) => {
        if ( to.name != '/register' && to.name != '/login' && ( this.$store.getters.userInfo.token == '' || this.$store.getters.userInfo.token == 'undefined') ) {
          // 如果用户没有登录并且访问一个需要登录的页面，则重定向到登录页面
          next('/login');
        } else {
          // 否则，继续正常的导航
          next();
        }
    });
  
    this.getScrollbarHeight();
    this.$store.state.share_url = window.location.origin+"/#/register/"
  },
  methods : {
    getScrollbarHeight() {
      const height2 = window.innerHeight;
      const width2 = window.innerWidth;
        //const scrollbarEl = this.$refs.scrollbarRef.$el;
        //const height = scrollbarEl.offsetHeight || scrollbarEl.clientHeight;

        this.$store.state.scroll.height = height2-60;
        this.$store.state.scroll.width = width2;
    }
  }
}
</script>

<style lang="scss">
/* 全局重置样式 */
* {
  box-sizing: border-box;
}

body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  background-color: #f5f5f5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 通用工具类 */
.clicked:hover {
  cursor: pointer;
  font-weight: 550;
}

.main-box {
  margin: 6px 0px;
}

.padding10 {
  padding: 10px;
}

.padding20 {
  padding: 20px;
}

.margin10 {
  margin: 10px;
}

.margin20 {
  margin: 20px;
}

.paddingtb10 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.paddinglr10 {
  padding-right: 10px;
  padding-left: 10px;
}

.paddinglr20 {
  padding-right: 20px;
  padding-left: 20px;
}

.margin-left {
  margin-left: 10px;
}

.margin-top {
  margin-top: 10px;
}

.font-left {
  text-align: left;
}

/* 状态颜色类 */
.flag1 { color: #ea3d3d; }
.flag2 { color: #ffc710; }
.flag3 { color: #3acb36; }
.flag4 { color: #1a70f1; }
.flag5 { color: #ba2fff; }
.flag6 { color: #f48804; }
.flag7 { color: #41b4fa; }
.flag8 { color: #e5b6b6; }
.flag9 { color: #9ba217; }
.flag10 { color: #e4248e; }

/* 边框样式 */
.border {
  border: 1px solid #dcdfe6;
  border-radius: 6px;
}

.border-blue {
  border: 2px solid #409eff;
  border-radius: 6px;
}

.white {
  color: #fff !important;
}

.green {
  color: #3acb36;
}

.red {
  color: #ea3d3d;
}

/* Element Plus 容器样式 */
.el-container {
  height: 100vh;
}

.el-header {
  background-image: linear-gradient(to bottom right, #2d3a5b 50%, #545c64 100%);
  padding: 0;
  height: 60px;
  z-index: 1000;
}

.el-main {
  background-color: #f5f5f5;
  padding: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  body, html {
    font-size: 13px;
  }
  
  .padding20 {
    padding: 15px;
  }
  
  .padding10 {
    padding: 8px;
  }
  
  .margin20 {
    margin: 15px;
  }
  
  .margin10 {
    margin: 8px;
  }
  
  .paddinglr20 {
    padding-right: 15px;
    padding-left: 15px;
  }
  
  .paddinglr10 {
    padding-right: 8px;
    padding-left: 8px;
  }
}

@media (max-width: 480px) {
  body, html {
    font-size: 12px;
  }
  
  .padding20 {
    padding: 10px;
  }
  
  .padding10 {
    padding: 6px;
  }
  
  .margin20 {
    margin: 10px;
  }
  
  .margin10 {
    margin: 6px;
  }
  
  .paddinglr20 {
    padding-right: 10px;
    padding-left: 10px;
  }
  
  .paddinglr10 {
    padding-right: 6px;
    padding-left: 6px;
  }
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 移动端优化 */
@media (max-width: 768px) {
  /* 禁用移动端双击缩放 */
  * {
    touch-action: manipulation;
  }
  
  /* 优化移动端点击区域 */
  button, .el-button {
    min-height: 44px;
    min-width: 44px;
  }
  
  /* 优化移动端输入框 */
  input, textarea, select {
    font-size: 16px; /* 防止iOS缩放 */
  }
}

/* 打印样式 */
@media print {
  .no-print {
    display: none !important;
  }
  
  body {
    background: white !important;
    color: black !important;
  }
}

/* 高对比度模式支持 */
@media (prefers-contrast: high) {
  .border {
    border-color: #000;
  }
  
  .white {
    color: #000 !important;
  }
}

/* 减少动画模式支持 */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
